module.exports = __webpack_public_path__ + "media/images/mes_180_bip-a1182c6c17ef9d55e45c72d52407f6d9.png";